import React from 'react';

const TermsOfService = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="max-w-4xl mx-auto px-4">
        <div className="bg-white rounded-lg shadow-md p-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-8">Terms of Service</h1>
          <div className="prose max-w-none">
            <p className="text-gray-600 mb-6">Last updated: January 3, 2026</p>
            
            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">Acceptance of Terms</h2>
            <p className="mb-6">By accessing and using GandalStock services, you accept and agree to be bound by the terms and provision of this agreement.</p>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">Description of Service</h2>
            <p className="mb-6">GandalStock provides stock market information, analysis, and investment insights. Our services are for informational purposes only and do not constitute financial advice.</p>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">Investment Disclaimer</h2>
            <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 mb-6">
              <p className="font-semibold text-yellow-800">Important: All investment information provided is for educational purposes only. Past performance does not guarantee future results. You should consult with a qualified financial advisor before making investment decisions.</p>
            </div>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">User Responsibilities</h2>
            <ul className="list-disc pl-6 mb-6">
              <li>Provide accurate account information</li>
              <li>Maintain the security of your account</li>
              <li>Use services in compliance with applicable laws</li>
              <li>Not share account credentials</li>
              <li>Make independent investment decisions</li>
            </ul>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">Subscription and Billing</h2>
            <ul className="list-disc pl-6 mb-6">
              <li>Subscriptions are billed monthly or annually</li>
              <li>Payments are processed securely through Stripe</li>
              <li>Cancellations take effect at the end of the billing period</li>
              <li>Refunds are provided according to our refund policy</li>
            </ul>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">Prohibited Uses</h2>
            <ul className="list-disc pl-6 mb-6">
              <li>Unauthorized access or use of our systems</li>
              <li>Redistribution of our proprietary content</li>
              <li>Use of automated systems to access our services</li>
              <li>Any illegal or harmful activities</li>
            </ul>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">Limitation of Liability</h2>
            <p className="mb-6">GandalStock shall not be liable for any direct, indirect, incidental, or consequential damages resulting from the use of our services or investment decisions made based on our information.</p>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">Termination</h2>
            <p className="mb-6">We reserve the right to terminate or suspend accounts that violate these terms or engage in prohibited activities.</p>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">Contact Information</h2>
            <p className="mb-4">For questions about these Terms of Service, contact us at:</p>
            <p className="mb-2">Email: legal@gandalstock.com</p>
            <p className="mb-6">Address: GandalStock, Inc.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;
